import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { InputAdornment, TextField, IconButton, Typography, Link } from '@mui/material'
import { Search as SearchIcon, ChevronRight as SubmitIcon, Close as CloseIcon } from '@mui/icons-material'
import GoogleReCaptcha from 'react-google-recaptcha'
import { translate } from '../../utils/resources'
import DEFAULT from '../../config/default'

interface SearchProps {
    size?: 'small' | 'medium',
    reCaptchaEnabled?: boolean,
    onClose?: () => void
}

const Search = ({ size = 'medium', reCaptchaEnabled = true, onClose }: SearchProps) => {

    const navigate = useNavigate()
    const [value, setValue] = useState('')

    const recaptchaRef = useRef<any>()

    const handleOnChange = (event: any) => {
        const val = event.target.value.trim()
        if(val.length > 0) {
            if ((!isNaN(parseFloat(val)) && isFinite(val))) {
                if (event.target.value.indexOf('.') !== -1) {
                    const newVal = event.target.value.split('.').join('')
                    if (!isNaN(parseFloat(newVal)) && isFinite(newVal) && newVal.length >= 2) {
                        setValue(newVal)
                    }
                } else if (event.target.value.indexOf(',') !== -1) {
                    const newVal = event.target.value.split(',').join('')
                    if (!isNaN(parseFloat(newVal)) && isFinite(newVal) && newVal.length >= 2) {
                        setValue(newVal)
                    }
                } else {
                    setValue(event.target.value)
                }
            } else {
                if (event.target.value.indexOf('.') !== -1) {
                    const newVal = event.target.value.split('.').join('')
                    if (!isNaN(parseFloat(newVal)) && isFinite(newVal) && newVal.length >= 2) {
                        setValue(newVal)
                    }
                } else if (event.target.value.indexOf(',') !== -1) {
                    const newVal = event.target.value.split(',').join('')
                    if (!isNaN(parseFloat(newVal)) && isFinite(newVal) && newVal.length >= 2) {
                        setValue(newVal)
                    }
                } 
            }
        } else {
            setValue('')
        }
    }

    const handleOnKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            handleRedirect()
        }
    }

    const handleOnFocus = (event: any) => {
        event.target.select()
    }

    const handleSubmit = () => {
        if (DEFAULT.api.countryCode === 'CH') {
            if (value.length >= 8) {
                if (value.length === 8 && value.startsWith('1')) {
                    navigate(`/consultora/${value}`)
                } else {
                    navigate(`/pedido/${value}`)
                }
            } else if (value.length >= 2 && value.length <= 7) {
                navigate(`/consultora/${value}`)
            }
        } else {
            if (value.length >= 8) {
                navigate(`/pedido/${value}`)
            } else if (value.length >= 2 && value.length <= 7) {
                navigate(`/consultora/${value}`)
            }
        }
        setValue('')
    }

    const handleRedirect = () => {
        if (reCaptchaEnabled) {
            recaptchaRef.current.executeAsync().then((value: any) => {
                if (value !== null) {
                    handleSubmit()
                }
            })
        } else {
            handleSubmit()
        }
    }

    return (
        <>
            <TextField
                value={value}
                fullWidth
                placeholder={translate('index.search.placeholder')}
                InputProps={{
                    startAdornment: <InputAdornment position="start"><SearchIcon/></InputAdornment>,
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={handleRedirect}
                                disabled={value.length < 2}
                                sx={{ 
                                    bgcolor: 'primary.main',
                                    '&:hover': {
                                        bgcolor: 'primary.dark'
                                    },
                                    '&:disabled': {
                                        bgcolor: 'primary.light'
                                    }
                                }}
                            >
                                <SubmitIcon sx={{ color: 'common.white' }}/>
                            </IconButton>
                            { onClose && (
                                <IconButton
                                    onClick={onClose}
                                    color="primary"
                                >
                                    <CloseIcon/>
                                </IconButton>
                            )}
                        </InputAdornment>
                    )
                }}
                inputProps={{
                    minLength: 2
                }}
                onChange={handleOnChange}
                onKeyDown={handleOnKeyDown}
                //onPaste={handleOnPaste}
                onFocus={handleOnFocus}
                size={size}
            />
            {reCaptchaEnabled && (
                <>
                    <Typography component="div" textAlign="center" variant="caption" color="textSecondary" sx={{ mt: 1 }}>
                        Este sitio está protegido por reCAPTCHA y Google. Al continuar estás aceptando <br />
                        {' '}los <Link href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Términos del servicio</Link> y la
                        {' '}<Link href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Política de privacidad</Link>.
                    </Typography>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <GoogleReCaptcha
                            ref={recaptchaRef}
                            sitekey={DEFAULT.project.googleReCaptcha as string}
                            size="invisible"
                        />
                    </div>
                </>
            )} 
        </>
    )
}

export default Search
